export const messages = {
  en: {
    allocationStorehouseHistoryAuditOrders: {
      page: {
        title: 'Allocation History Audit Orders',
        subtitle: 'Track completed allocation audit orders',
        empty: 'No history audit orders found'
      },
      title: 'Allocation History Audit Orders',
      back: 'Back',
      refresh: 'Refresh',
      allocationNumber: 'Allocation Number',
      allocationCount: 'Allocation Count',
      applicant: 'Applicant',
      status: 'Status',
      time: 'Time',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch allocation history audit orders'
    }
  },
  zh: {
    allocationStorehouseHistoryAuditOrders: {
      page: {
        title: '调拨已办单',
        subtitle: '查看已完成的调拨审核单',
        empty: '暂无已办单数据'
      },
      title: '调拨已办单',
      back: '返回',
      refresh: '刷新',
      allocationNumber: '调拨编号',
      allocationCount: '调拨数量',
      applicant: '申请人',
      status: '状态',
      time: '时间',
      operation: '操作',
      detail: '详情',
      fetchError: '获取调拨已办单失败'
    }
  }
}